export enum UserStatus {
  INACTIVE = 'INACTIVE',
  DELETED = 'DELETED',
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
}

export const UserStatusLabels: Record<UserStatus, string> = {
  [UserStatus.PENDING]: 'Pendiente',
  [UserStatus.INACTIVE]: 'Inactivo',
  [UserStatus.DELETED]: 'Eliminado',
  [UserStatus.ACTIVE]: 'Activo',
};
